import React from "react";
import { WhatsappLogo } from "@phosphor-icons/react";

export default function WhatsappFAB() {
  return (
    <a
      data-testid="whatsapp-fab"
      href="https://wa.me/7054986771?text=Hi%20Maxine%2C%20I%20have%20a%20question."
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 bg-[#25D366] hover:bg-[#1fb257] text-white shadow-lg shadow-emerald-900/20 flex items-center justify-center rounded-full transition-transform duration-200 hover:-translate-y-0.5"
    >
      <WhatsappLogo size={26} weight="fill" />
    </a>
  );
}
